import { LanguageModel } from '../api/Argentia/model/contracts'

export const mapLanguagesResponse = (languages: any): LanguageModel[] => {
  return languages.map(language => mapLanguageResponse(language))
}

export const mapLanguageResponse = (language: any): LanguageModel => {
  return {
    id: language.id,
    code: language.code,
    description: language.description,
    lgDefault: language.lgDefault
  }
}

export const mapDefaultLanguage = (languages: LanguageModel[]) => {
  return languages.find(l => l.lgDefault === true)
}
